module.exports = __webpack_public_path__ + "static/img/icon_pd_course.7856861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_pd_course.png
// module id = tOrI
// module chunks = 1